var paramGet = require('./paramGet.js');

function init() {
    if (
        $.urlParam('utm_campaign') ||
        $.urlParam('utm_content') ||
        $.urlParam('utm_medium') ||
        $.urlParam('utm_source') ||
        $.urlParam('utm_term')
    ) {
        // console.log('! Found NEW UTM tag');
        document.cookie = 'utm_campaign=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        document.cookie = 'utm_content=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        document.cookie = 'utm_medium=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        document.cookie = 'utm_source=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
        document.cookie = 'utm_term=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
}

module.exports = { init };